import {Route, Routes} from 'react-router-dom';
import InboxPage from '../pages/InboxPage';
import KnowledgePage from '../pages/KnowledgePage';
import ConnectionsPage from '../pages/ConnectionsPage';
import FeedbackPage from '../pages/FeedbackPage';
import SettingsPage from '../pages/SettingsPage';

export const WorkspaceRoutes = () => <Routes>
  <Route path="/" element={<InboxPage/>}/><Route path="/knowledge" element={<KnowledgePage/>}/>
  <Route path="/connections" element={<ConnectionsPage/>}/><Route path="/feedback" element={<FeedbackPage/>}/>
  <Route path="/settings" element={<SettingsPage/>}/><Route path="*" element={<InboxPage/>}/>
</Routes>;